/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/InteractiveEducationLayout.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { View } from 'foundations-components/components/View';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import CompanionTabWrapper from '../components/CompanionTabWrapper.migrated';
import QuizMeTabContainer from '../components/QuizMeTabContainer.migrated';
import SummarizeTab from '../components/SummarizeTab.migrated';
import AdaptToIndustryTab from '../components/AdaptToIndustryTab.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/InteractiveEducationLayout.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const InteractiveEducationLayout = ({
  displayInteractiveEducation,
  interactiveEducationEnabled,
  contentType,
  interactiveContentTrackingProps,
  interactiveEducationProps,
  lesson,
  lessonContentId,
  primaryContentId,
  videoTitle,
  children
}) => {
  const {
    isNotLaptop
  } = useMediaQuery();
  const {
    handleTriggerAsyncQuizGeneration,
    generateQuizError,
    generateQuizLoading,
    onRegenerateSingleVideoQuiz,
    summary,
    summaryCorrelationId,
    summaryError,
    summaryLoading,
    refetchSummary,
    videoDuration,
    activeIndustry,
    useCase,
    useCaseCorrelationId,
    useCaseError,
    useCaseLoading,
    refetchUseCase,
    generateForIndustry
  } = interactiveEducationProps;
  const isAdaptToIndustryOpen = displayInteractiveEducation === 'ADAPT_TO_INDUSTRY';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, interactiveEducationEnabled && isNotLaptop && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(AccordionTransition, {
        open: displayInteractiveEducation === 'QUIZ_ME',
        children: /*#__PURE__*/_jsx(QuizMeTabContainer, {
          additionalTracking: interactiveContentTrackingProps,
          asyncGenerateError: !!generateQuizError,
          asyncGenerateLoading: generateQuizLoading,
          contentType: contentType,
          lesson: lesson,
          lessonContentId: lessonContentId,
          onAsyncRegenerateQuiz: handleTriggerAsyncQuizGeneration,
          onRegenerateSingleVideoQuiz: onRegenerateSingleVideoQuiz,
          primaryContentId: primaryContentId
        })
      }), /*#__PURE__*/_jsx(AccordionTransition, {
        open: displayInteractiveEducation === 'SUMMARIZATION',
        children: /*#__PURE__*/_jsx(View, {
          paddingBlockStart: "400",
          children: /*#__PURE__*/_jsx(CompanionTabWrapper, {
            children: /*#__PURE__*/_jsx(SummarizeTab, {
              additionalTracking: interactiveContentTrackingProps,
              contentType: contentType,
              correlationId: summaryCorrelationId,
              lessonContentId: lessonContentId,
              primaryContentId: primaryContentId,
              refetchSummary: refetchSummary,
              summary: summary,
              summaryError: summaryError,
              summaryLoading: summaryLoading,
              videoDuration: videoDuration
            })
          })
        })
      }), /*#__PURE__*/_jsx(AccordionTransition, {
        open: isAdaptToIndustryOpen,
        children: /*#__PURE__*/_jsx(View, {
          paddingBlockStart: "400",
          children: /*#__PURE__*/_jsx(CompanionTabWrapper, {
            children: /*#__PURE__*/_jsx(AdaptToIndustryTab, {
              activeIndustry: activeIndustry,
              additionalTracking: interactiveContentTrackingProps,
              contentId: primaryContentId,
              contentType: contentType,
              correlationId: useCaseCorrelationId,
              isActive: isAdaptToIndustryOpen,
              onGenerateForIndustry: generateForIndustry,
              refetchUseCase: refetchUseCase,
              useCase: useCase,
              useCaseError: useCaseError,
              useCaseLoading: useCaseLoading,
              videoTitle: videoTitle
            })
          })
        })
      })]
    })]
  });
};